import { useEffect } from "react";
import { X } from "lucide-react";

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onClose,
  destructive = false,
  loading = false,
  testid = "confirm-dialog",
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4" data-testid={testid}>
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div
        className="relative w-full max-w-md rounded-2xl border p-7"
        style={{ background: "#FAF6EC", borderColor: "rgba(27,67,50,0.15)", boxShadow: "0 20px 60px -20px rgba(27,67,50,0.5)" }}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 inline-flex h-8 w-8 items-center justify-center rounded-full hover:bg-black/5"
          aria-label="Close"
          data-testid={`${testid}-close`}
        >
          <X size={14} />
        </button>
        <h3 className="font-serif text-2xl" style={{ color: "#1B4332" }}>{title}</h3>
        {message && <p className="mt-3 text-sm leading-relaxed" style={{ color: "#2A2621" }}>{message}</p>}
        <div className="mt-7 flex flex-wrap gap-3 justify-end">
          <button
            type="button"
            onClick={onClose}
            className="btn-outline-forest"
            disabled={loading}
            data-testid={`${testid}-cancel`}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={destructive ? "" : "btn-gold"}
            data-testid={`${testid}-confirm`}
            style={
              destructive
                ? {
                    background: "#8A2A2A",
                    color: "#FAF6EC",
                    borderRadius: 9999,
                    padding: "12px 28px",
                    fontSize: 14,
                    border: "1px solid #8A2A2A",
                  }
                : undefined
            }
          >
            {loading ? "Working&hellip;" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
